import { Component, OnInit } from '@angular/core';
import { FiADIntegrationGroupMappingComponent } from './group-mapping/group-mapping.component';
import { MobileTabsModel } from '../../utilities/mobile-tabs/mobile-tabs.model';
import { MobileTabModel } from '../../utilities/mobile-tabs/mobile-tab.model';
import { AppTextService } from '../../shared/app-text';
import { FiADIntegrationADImportComponent } from './ad-import/ad-import.component';
import { FiStateService } from '../../shared/fi-state-proxy/fi-state.proxy.service';
import { SaveChangesWarningService } from '../../shared/fi-shared-services/save-changes-warning.service';
import { Subject } from 'rxjs';

@Component({
    selector: 'fi-ad-external-platform-integration',
    templateUrl: './ad-integration.component.html',
    viewProviders: [
        {
            provide: 'onSaveClick',
            useFactory: (context) => context.onSaveClick,
            deps: [FiAdIntegrationComponent],
        },
        {
            provide: 'saveButtonAccessor',
            useFactory: (context) => ({
                onSaveClick: context.onSaveClick,
            }),
            deps: [FiAdIntegrationComponent],
        },
        {
            provide: 'setDirtyCallback',
            useFactory: (context: FiAdIntegrationComponent) => (state) => context.setDirty(state),
            deps: [FiAdIntegrationComponent],
        },
    ],
    standalone: false,
})
export class FiAdIntegrationComponent implements OnInit {
    componentFactory = FiADIntegrationGroupMappingComponent;

    tabs = new MobileTabsModel();

    tabToFactoryMap = {
        GroupMapping: FiADIntegrationGroupMappingComponent,
        ImportFromAD: FiADIntegrationADImportComponent,
    };

    tabToStateMap = {
        GroupMapping: 'ADIntegration.GroupMapping',
        ImportFromAD: 'ADIntegration.Import',
    };

    constructor(
        private appTextService: AppTextService,
        private stateService: FiStateService,
        private saveChangesWarningService: SaveChangesWarningService,
    ) {}

    ngOnInit() {
        this.tabs.Tabs.push(
            new MobileTabModel(this.appTextService.get('ad_integration.group_mapping_title'), 'GroupMapping'),
        );
        this.tabs.Tabs.push(
            new MobileTabModel(this.appTextService.get('ad_integration.import_from_ad'), 'ImportFromAD'),
        );
        this.initSelectedTabFromState();
        this.updateSelectedTabComponent();
        this.startChangesWarning();
    }

    startChangesWarning() {
        const data = () => ({ isDirty: this._isDirty });
        this.saveChangesWarningService.start(data);
    }

    updateSelectedTabComponent() {
        this.componentFactory = this.tabToFactoryMap[this.tabs.Tabs[this.tabs.SelectedIndex].PropertyName];
    }

    originalSelectedIndex = -1;

    tabSelectedClick($event) {
        if (this.originalSelectedIndex === $event) {
            return;
        }

        const state = this.tabToStateMap[this.tabs.Tabs[this.tabs.SelectedIndex].PropertyName],
            transitionOptions = {
                inherit: false,
                location: 'replace' as const,
                notify: false,
            };

        const savedIndex = this.tabs.SelectedIndex;

        const next = () => {
            this.originalSelectedIndex = $event;
            this._isDirty = false;
            setTimeout(() => {
                this.tabs.SelectedIndex = savedIndex;
                this.updateSelectedTabComponent();
                this.stateService.go(state, {}, transitionOptions);
            });
        };

        if (this._isDirty) {
            setTimeout(() => {
                this.tabs.SelectedIndex = this.originalSelectedIndex;
                this.saveChangesWarningService.showConfirmDialog().onYesButtonClick(next);
            });
        } else {
            next();
        }
    }

    initSelectedTabFromState() {
        this.tabs.Tabs.forEach((tab, index) => {
            const state = this.tabToStateMap[tab.PropertyName];
            if (state && state == this.stateService.current.name) {
                this.tabs.SelectedIndex = index;
                this.originalSelectedIndex = index;
            }
        });
    }

    onSaveClick = new Subject<void>();

    saveClick() {
        this.onSaveClick.next();
    }

    isShowSaveButton() {
        return this.tabs.SelectedIndex == 0;
    }

    private _isDirty: boolean = false;

    setDirty(state = true) {
        this._isDirty = state;
    }
}
